import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Tabs, Tab, Box } from "@mui/material";
import Sms from "./MarketingTab/Sms";
import Email from "./MarketingTab/Email";
import PushNotification from "./MarketingTab/PushNotification";
import WhatsApp from "./MarketingTab/WhatsApp";

const theme = createTheme({
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          textTransform: "none",
          fontSize: { xs: "11px", sm: "12px", md: "13px" },
          padding: { xs: "8px 4px", sm: "10px 6px", md: "12px 8px" },
          minWidth: { xs: "100px", sm: "120px", md: "140px" },
          "&.Mui-selected": {
            color: "#F68A20",
            fontWeight: 700,
          },
          "&:not(.Mui-selected)": {
            color: "#6b7280",
            "&:hover": {
              color: "#F68A20",
            },
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: { xs: "48px", sm: "56px" },
        },
        flexContainer: {
          justifyContent: { xs: "flex-start", sm: "center" },
          gap: { xs: "4px", sm: "8px" },
        },
      },
    },
  },
  palette: {
    secondary: {
      main: "#F68A20",
    },
  },
});

const formatLabel = (label) =>
  `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;

const Marketing = ({ eventDetails, token, userID, isLoading }) => {
  const [selectedTab, setSelectedTab] = useState("1");
  
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{ backgroundColor: "white", width: "100%" }}
        className="set-event-rightbar-content-hearder"
      >
        {/* ===== FIXED HEADER - MATCHES PARTICIPANTS.JSX ===== */}
        <Box
          sx={{
            position: "fixed",
            backgroundColor: "white",
            top: "70px",  // Start below main app header
            left: { xs: "0", sm: "253px", md: "254px" },
            right: "0",
            width: { 
              xs: "100%", 
              sm: "calc(100% - 253px)", 
              md: "calc(100% - 254px)" 
            },
            zIndex: 1000,
            paddingLeft: { xs: "8px", sm: "12px", md: "20px" },
            paddingRight: { xs: "8px", sm: "12px", md: "20px" },
            boxSizing: "border-box",
            paddingTop: "5px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            borderBottom: "1px solid rgba(246, 138, 32, 0.1)",
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="marketing navigation tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{ 
              width: "100%",
              maxWidth: "100%",
              "& .MuiTabs-indicator": {
                backgroundColor: "#F68A20",
                height: "3px",
              },
              "& .MuiTab-root": {
                minWidth: { xs: "100px", sm: "120px", md: "140px" },
                fontSize: { xs: "11px", sm: "12px", md: "13px" },
                padding: { xs: "8px 4px", sm: "10px 6px", md: "12px 8px" },
              },
            }}
          >
            <Tab value="1" label={formatLabel("SMS")} />
            <Tab value="2" label={formatLabel("Email")} />
            <Tab value="3" label={formatLabel("Push Notifications")} />
            <Tab value="4" label={formatLabel("WhatsApp")} />
          </Tabs>
        </Box>
      </Box>

      {/* =====-- CONTENT WITH SPACING FOR FIXED HEADER--===== */}
      <Box
        sx={{
          paddingTop: { xs: "70px", sm: "75px", md: "80px" },
          minHeight: "calc(100vh - 70px)",
          backgroundColor: "#f8fafc",
        }}
      >
        {selectedTab === "1" && (
          <div className="px-5 py-4">
            <Sms userID={userID} token={token} eventDetails={eventDetails} />
          </div>
        )}
        {selectedTab === "2" && (
          <div className="px-5 py-4">
            <Email userID={userID} token={token} eventDetails={eventDetails} />
          </div>
        )}
        {selectedTab === "3" && (
          <div className="px-5 py-4">
            <PushNotification
              userID={userID}
              token={token}
              eventDetails={eventDetails}
            />
          </div>
        )}
        {selectedTab === "4" && (
          <div className="px-5 py-4">
            <WhatsApp userID={userID} token={token} eventDetails={eventDetails} />
          </div>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default Marketing;